import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import LendingAccountSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/LendingAccountSettings';
import SimulationSettingsChanges from "@/models/Accounts/Shared/Toolkit/SimulationSettingsChanges";
import ScheduleInstallment from '@/models/Accounts/LendingAccounts/Schedules/ScheduleInstallment';
import Amount from "@/models/Shared/Amount";

export default class Simulation extends BaseInstitutionEntity {
    accountId: string
    name: string;
    version: string;
    lendingSettings: LendingAccountSettings;
    lendingSettingsChanges: SimulationSettingsChanges[] = [];
    loanSchedule: ScheduleInstallment[] = [];
    totalAmount: Amount = new Amount;
    totalPrincipal: Amount = new Amount;
    totalInterest: Amount = new Amount;
}